export const SpinConstants = {
    RENDERING_GROUP_SPIN_BASE: 0,
    RENDERING_GROUP_DEFAULT: 1,
    RENDERING_GROUP_SPIN_OVERLAY: 2,
    RENDERING_GROUP_HIGHLIGHT: 3,
    RENDERING_GROUP_ICON: 4,
}
